import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import BoardProvider from './BoardProvider';
import BoardMain from '../../component/Board/BoardMain/BoardMain';

const Board: FC = () => {
    return (
        <BoardProvider>
            <BoardMain/>
        </BoardProvider>
    );
};

export default observer(Board);